import Vue from 'vue'
import axios from 'axios'
import { APP_API_URL } from '../../const/api'

export const axiosChatApi = () => {
  const handleError = async (error) => {
    if (error.response && !error.response.config.url.includes('rest-auth')) {
      if (parseInt(error.response && error.response.status) === 401) {
        // await store.dispatch('auth/logout');
      }
    }
  }

  // create instance
  const api = axios.create({
    baseURL: APP_API_URL,
    headers: {
      common: {
        // 'Content-Type': 'application/json',
        // Accept: '*/*',
        // 'X-Requested-With': 'XMLHttpRequest',
      },
    },
  })

  api.interceptors.request.use(
    (x) => {
      // console.log(`${x.method.toUpperCase()} | ${x.url}`, x.params, x.data)

      const token = localStorage.getItem('auth_token_default')

      if (token) x.headers.common.authorization = `Bearer ${token}`

      return x
    },
    async (error) => {
      await handleError(error)
      return Promise.reject(error)
    }
  )

  api.interceptors.response.use(
    (x) => {
      // console.log(`${x.status} | ${x.config.url}`, x.data)

      return x
    },
    async (error) => {
      await handleError(error)
      return Promise.reject(error)
    }
  )

  Vue.prototype.$chatApi = api
}

// helpers
const mapApiError = (error) => {
  const data = error.response.data
  let message = data.message

  // TODO - refactor to case switch
  if (error.response.status === 500) {
    message = 'Server error'
  }

  return {
    message: message,
    errors: data.errors,
    code: error.response.status,
  }
}

// services

/** group types

  'id' => 1, //self::TYPE_PUBLIC,
  'title' => 'public group',

  'id' => 2, // self::TYPE_PRIVATE,
  'title' => 'private p2p chat',

  'id' => 3, //self::TYPE_GROUP,
  'title' => 'chat group',
*/

const endpoints = {
  members: '/users/',

  group: '/chat/group/',
  groupId: (id) => '/chat/group/:id'.replace(':id', id),
  groupUser: ({ id, user_id }) => '/chat/group/:id/:user_id'.replace(':id', id).replace(':user_id', user_id),

  message: '/chat/message/',
  messageReply: (id) => '/chat/message/:id/reply'.replace(':id', id),
  messageId: (id) => '/chat/message/:id'.replace(':id', id),
  messageRead: (id) => '/chat/message/:id/read'.replace(':id', id),
  messageForward: (id) => '/chat/message/:id/forward'.replace(':id', id),
  spam: (id) => '/chat/message/:id/spam'.replace(':id', id),
  unspam: (id) => '/chat/message/:id/unspam'.replace(':id', id),
  messageSearch: '/chat/search',
}

export const membersGetService = async (request) => {
  try {
    const { data } = await Vue.prototype.$chatApi.get(endpoints.members, request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const groupGetService = async (request) => {
  try {
    const { data } = await Vue.prototype.$chatApi.get(endpoints.group, request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const groupPostService = async (request) => {
  try {
    /**
     * @param "title": String
     * @param "topic" String
     * @param "description" String
     * @param "type" Integer
     * @param "members" Array
     */
    const { data } = await Vue.prototype.$chatApi.post(endpoints.group, request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const groupEditService = async (request) => {
  try {
    /**
     * @param "title": String,
     * @param "type": Integer
     */
    const { data } = await Vue.prototype.$chatApi.post(endpoints.groupId(request.id), request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const groupDeleteService = async (id) => {
  try {
    const { data } = await Vue.prototype.$chatApi.delete(endpoints.groupId(id))

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const memberAddGroup = async (request) => {
  try {
    const { data } = await Vue.prototype.$chatApi.post(
      endpoints.groupUser({ id: request.group, user_id: request.user_id }),
      request
    )

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const memberDropGroup = async (request) => {
  try {
    const { data } = await Vue.prototype.$chatApi.post(
      endpoints.delete({ id: request.group, user_id: request.user_id }),
      request
    )

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const messageGetService = async ({ group_id }) => {
  try {
    const filter = group_id ? `[group_id]=${group_id}` : ''
    const { data } = await Vue.prototype.$chatApi.get(`${endpoints.message}?filter${filter}`)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const messagePostService = async (request, replyId) => {
  try {
    /**
     * @param "group_id": Integer,
     * @param "type": Integer
     * @param "content": String
     */

    const endpoint = replyId ? endpoints.messageReply(replyId) : endpoints.message;
    const { data } = await Vue.prototype.$chatApi.post(endpoint, request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const chatDropMember = async ( id, user_id) => {
  try {
    /**
     * @param "group_id": Integer,
     * @param "type": Integer
     * @param "content": String
     */

    const { data } = await Vue.prototype.$chatApi.post(endpoints.groupUser({id, user_id}))

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const messageReadService = async (request) => {
  try {
    /**
     * @param "id": Integer
     */
    const { data } = await Vue.prototype.$chatApi.post(endpoints.messageRead(request.id), request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const messageEditService = async (request) => {
  try {
    /**
     * @param "group_id": Integer,
     * @param "type": Integer
     * @param "content": String
     */
    const { data } = await Vue.prototype.$chatApi.put(endpoints.messageId(request.id), request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const messageDeleteService = async (request) => {
  try {
    const { data } = await Vue.prototype.$chatApi.delete(endpoints.messageId(request.id), request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const messageSpamService = async (id, state) => {
  try {
    const nameR = state ? 'spam' : 'unspam';
    const { data } = await Vue.prototype.$chatApi.put(endpoints[nameR](id))

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const messageForwardService = async (request, messageId) => {
  try {
    const { data } = await Vue.prototype.$chatApi.post(endpoints.messageForward(messageId), request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}

export const messageSearchService = async (request) => {
  try {
    const { data } = await Vue.prototype.$chatApi.get(endpoints.messageSearch, request)

    return [null, data]
  } catch (error) {
    return [mapApiError(error), null]
  }
}
